import { Component } from '@angular/core';
import { Ndg } from 'src/app/model/ndg';
import { NdgService } from 'src/app/service/ndg.service';

@Component({
  templateUrl: './internal.component.html'
})
export class InternalComponent {
  constructor(
    private ndgService: NdgService
  ) {}

  get ndg(): Ndg | undefined {
    return this.ndgService.activeNdg;
  }
}
